import httpStore from "@/api/httpStore.js";

// Get all vehicle makes
export function getVehicleMakes() {
  return httpStore
    .get("vehicles/vehicles_makes")
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Get models for selected makes
export function getModelsForMakes(selectedMakes) {
  return httpStore
    .post("vehicles/makes_models", { selectedMakes })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Get years for selected models
export function getYearsForModels(selectedMakesModels) {
  return httpStore
    .post("vehicles/makes_models_years", { selectedMakesModels })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Get vehicle options for selected years
export function getVehicleOptions(selectedMakesModelsYears) {
  return httpStore
    .post("vehicles/vehicles_options", { selectedMakesModelsYears })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Get all vehicle families
export function getVehicleFamilies() {
  return httpStore
    .get("vehicles/vehicle_families")
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Get vehicles by family catalog code
export function getVehiclesByFamily(catalogCode) {
  return httpStore
    .post("vehicles/vehicles_by_family", { catalog_code: catalogCode })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
